module.exports = __webpack_public_path__ + "static/launchpad-5e2fb2141c231be2d63ff1deba4577bd.png";